import {  Flex, Spacer } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { PageTitle } from './PageTitle';
import { useSideNav } from '@/hooks/useSideNav';

export interface PageHeaderProps extends PropsWithChildren {
  title: string;
  breadcrumb?: React.ReactNode,
  icon?: React.ReactNode,
}

export function PageHeader({ title, children, breadcrumb, icon }: PageHeaderProps) {

  const { buttonProps, open } = useSideNav()

  return (
        <Flex 
            p={3} 
            minH={'64px'} 
            alignItems={'center'}
            role='heading' 
            flexWrap="nowrap" 
            bg={'#0f4f6d'} 
            zIndex={999} 
            position={'sticky'} 
            top={0} 
            color={'#ffffff'}
        >
          <Flex direction={'column'} gap={1}>
            <Flex alignItems="center" gap={1}>
              {icon && <Flex>{icon}</Flex>}
              
              <PageTitle>{title}</PageTitle>
            </Flex>
          </Flex>

          <Spacer flex={1} minW="50px" />

          {children}
        </Flex>
    );
}
